import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, RecursoDisponibilidade } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class RecursoDisponibilidadeService extends BaseResourceService<RecursoDisponibilidade> {

  constructor(
    protected injector: Injector
  ) {
    super(`recursos-disponibilidades`, injector);
  }

}
